import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LegalPrivacy = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">Política de Privacidad</h1>
          
          <div className="prose prose-invert prose-slate max-w-none">
            <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-8 space-y-6 text-slate-300">
              <p className="text-slate-400 italic">
                Última actualización: Diciembre 2025
              </p>
              
              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">1. Información que Recopilamos</h2>
                <p>
                  Recopilamos información limitada cuando usted:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Se suscribe a nuestro newsletter (email)</li>
                  <li>Envía un mensaje a través del formulario de contacto (nombre, email, mensaje)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">2. Uso de la Información</h2>
                <p>
                  Utilizamos su información para:
                </p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Enviar actualizaciones sobre Blox (si se suscribió al newsletter)</li>
                  <li>Responder a sus consultas</li>
                  <li>Mejorar nuestros servicios</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">3. Protección de Datos</h2>
                <p>
                  No vendemos ni compartimos su información personal con terceros. 
                  Sus datos se almacenan de forma segura y se utilizan únicamente para los fines descritos.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-white mb-4">4. Contacto</h2>
                <p>
                  Para consultas sobre privacidad, contáctenos en: 
                  <a href="mailto:blox.com.py@gmail.com" className="text-cyan-400 hover:text-cyan-300">
                    blox.com.py@gmail.com
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPrivacy;
